import {
  FETCH_INTEGRATION,
  FETCHING_ALERTS,
  ALERTS_FETCHED,
  ALERT_INTEGRATION
} from "../actions/";

const initialState = {
  loading: true,
  response: null,
  alertList:null
};

const integration = function (state = initialState, action) {
  switch (action.type) {
    case FETCH_INTEGRATION:
      return {
        ...state,
        response: action.payload,
        loading: true,
      };
      case ALERT_INTEGRATION:
      return {
        ...state,
        alertList: action.payload,
        loading: true,
      };
    case FETCHING_ALERTS:
      return {
        ...state,
        resalert: null,
        loading: true,
      };
    case ALERTS_FETCHED:
      return {
        ...state,
        resalert: action.payload,
        loading: false,
      };
    default:
      return {
        ...state,
      };
  }
};
export default integration;
